"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonNullable = isNonNullable;
exports.is = isNonNullable;
exports.assertNonNullable = assertNonNullable;
exports.assert = assertNonNullable;
exports.ensureNonNullable = ensureNonNullable;
exports.ensure = ensureNonNullable;
exports.createUnwrapOr = createUnwrapOr;
exports.mapNonNullable = mapNonNullable;
exports.map = mapNonNullable;
exports.createMapNonNullable = createMapNonNullable;
exports.createMap = createMapNonNullable;
const tslib_1 = require("tslib");
const getFunctionDisplayName_ts_1 = tslib_1.__importDefault(require("./function/getFunctionDisplayName.js"));
function isNonNullable(val) {
    return val !== null && val !== undefined;
}
function assertNonNullable(value, msg = "NonNullable assertion failure on value") {
    if (value === null || value === undefined) {
        throw new Error(msg);
    }
}
function ensureNonNullable(value, msg = "NonNullable assertion failure on value") {
    if (value === null || value === undefined) {
        throw new Error(msg);
    }
    return value;
}
function createUnwrapOr(or) {
    function unwrapOr(val) {
        if (val !== null && val !== undefined) {
            return val;
        }
        return or;
    }
    return unwrapOr;
}
function mapNonNullable(value, mapFn) {
    if (value === null || value === undefined) {
        return value;
    }
    return mapFn(value);
}
function createMapNonNullable(mapFn) {
    const createMapNonNullableInner = (value) => {
        if (value === null || value === undefined) {
            return value;
        }
        return mapFn(value);
    };
    createMapNonNullableInner.displayName = `createMapNonNullable_${(0, getFunctionDisplayName_ts_1.default)(mapFn)}`;
    return createMapNonNullableInner;
}
